<template>
  <div class="tab-container">
    <app-spinner v-if="!page_loaded" />
    <template v-else>
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        class="table-default"
      >
        <template #h__full_name>
          <div class="table-default__left">Full name</div>
        </template>
        <template #full_name="{ row}">
          <div class="table-default__left">
            <router-link :to="{name: 'clients-detail', params: {id: row.client.id }}" class="table-default__link-border">
              {{ row.client.full_name }}
            </router-link>
          </div>
        </template>
        <template #days="{ row }">{{ row.days_before }}</template>
        <template #sent="{ row }">{{ dateTimeFormat(row.created_at) }}</template>
        <template #status="{ row }">
          <span
            class="status-tag"
            :style="{ 'backgroundColor': row.sendpulse_log?.status ? '#77b017' : '#e85c20' }"
          >
            {{ row.sendpulse_log?.status ? 'ОК' : 'ERROR' }}
          </span>
        </template>
      </v-client-table>
    </template>
  </div>
</template>

<script>
import { getClientsEmailNotifications } from '@/http'
import { format, parseISO } from 'date-fns'

export default {
  name: 'ClientsGroupsDetailReminders',
  data() {
    return {
      page_loaded: false,
      table: {
        items: [],
        columns: ['full_name', 'days', 'sent', 'status'],
        options: {
          headings: {
            select: '',
            full_name: 'Full name',
            days: 'Days left',
            sent: 'Sent',
            status: 'Status',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 50,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
    }
  },
  created() {
    getClientsEmailNotifications({ group: this.$route.params.id })
      .then(response => {
        this.table.items = response.data
        this.page_loaded = true
      })
  },
  methods: {
    dateTimeFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy HH:mm') : '-'
    },
  }
}
</script>
